import { Component } from '@angular/core';

/**
 * Generated class for the CarlisleHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'carlisle-header',
  templateUrl: 'carlisle-header.html'
})
export class CarlisleHeaderComponent {

  text: string;

  constructor() {
    console.log('Hello CarlisleHeaderComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/carlisle-header/carlisle-header.ts